import * as React from "react";
import TabPage from "./tabPage";

interface IProps {
  tabs: Vingle.ITab[];
  vingleTabType: Vingle.VingleTabType;
  onTabChange?: (selectedTab: Vingle.ITab) => void;
  wrapperClassName?: string;
}

interface IState {
  selectedTab: Vingle.ITab;
}

const getDefaultTab = (tabs: Vingle.ITab[]): Vingle.ITab => {
  return tabs.find(tab => Boolean(tab.default)) || tabs[0];
};

class VingleTab extends React.Component<IProps, IState> {
  public readonly state: IState = {
    selectedTab: getDefaultTab(this.props.tabs),
  };

  public componentDidUpdate(prevProps: IProps) {
    if (
      getDefaultTab(prevProps.tabs).key !== getDefaultTab(this.props.tabs).key
    ) {
      this.setState({
        selectedTab: getDefaultTab(this.props.tabs),
      });
    }
  }

  public render() {
    const { tabs, wrapperClassName, vingleTabType } = this.props;

    return (
      <TabPage
        tabs={tabs}
        selectedTab={this.state.selectedTab}
        wrapperClassName={wrapperClassName}
        vingleTabType={vingleTabType}
        onTabClick={this.handleClick}
      />
    );
  }

  private readonly handleClick = (selectedTab: Vingle.ITab) => {
    if (this.state.selectedTab !== selectedTab) {
      this.setState({
        selectedTab,
      });
      if (this.props.onTabChange) this.props.onTabChange(selectedTab);
    }
  };
}
export default VingleTab;
